@if (loadingData) {
<div class="limitation-placeholder">
  <img src="assets/img/arrow-filter-sm.png" alt="">
</div>
}

@if (!loadingData) {
<div class="limitation-screen-shell">
  <div class="entityDetails">
    <table style="width: 100%;">
      <tbody>
        <tr>
          <td class="LayerLine1" nowrap>Group Type:</td>
          <td class="LayerData1" nowrap>{{ groupType || 'N/A' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="limitation-content">
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    @if (!loading && errorMessage) {
<div class="error">{{ errorMessage }}</div>
}

    @if (!loading && !errorMessage) {

@switch (activeView) {

      <!-- Limitation Summary -->
      @case ('summary') {

        <div class="summary-wrapper">
          <div class="summary-title"><h3>Limitation Summary</h3></div>
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 10%;">IRS Form No</th>
                <th style="width: 10%;">Schedule</th>
                <th style="width: 10%;">Part No</th>
                <th style="width: 10%;">Line No</th>
                <th style="width: 50%;">Line Description</th>
                <th style="width: 10%;">Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (row of detailRows; track $index) {
<tr [ngStyle]="row.ROW_TYPE === 'HIGHLIGHT' ? {'background-color': '#FFCD02'} : null">
                <td>{{ row.IRS_FORM_NO }}</td>
                <td>{{ row.SCHEDULE }}</td>
                <td>{{ row.PART_NO }}</td>
                <td>{{ row.LINE_NO }}</td>
                <td>{{ row.LINE_DESCRIPTION }}</td>
                <td class="text-right">{{ formatAmount(row.AMOUNT) }}</td>
              </tr>
}
            </tbody>
          </table>
          @if (detailRows.length === 0) {
<div class="no-data">No data returned for this tab and filter set.</div>
}
        </div>
      
}

      <!-- 1231 Gain/Loss Analysis -->
      @case ('1231') {

        <div class="divShadow">
          <div class="summary-title"><h3>1231 Gain/Loss Summary</h3></div>
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 25%;">Entity Type</th>
                <th style="width: 25%;">Line 7 Amount</th>
                <th style="width: 25%;">Amount on Line 8 of 4797</th>
                <th style="width: 25%;">RC to D</th>
              </tr>
            </thead>
            <tbody>
              @for (row of summaryRows; track trackByIndex($index)) {
<tr>
                <td><input class="form-control" [value]="row.ENTITY_TYPE" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.LINE_7_AMOUNT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.LINE_8_AMT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.RECLASS_SCH_D_AMT)" readonly /></td>
              </tr>
}
            </tbody>
          </table>
          @if (summaryRows.length === 0) {
<div class="no-data">No summary rows for this filter set.</div>
}
        </div>

        <div class="divShadow">
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 12%;">Year</th>
                <th style="width: 18%;">Line 7 Amount</th>
                <th style="width: 17%;">Previous Loss</th>
                <th style="width: 17%;">Carry Over Loss</th>
                <th style="width: 18%;">Amount on Line 8 of 4797</th>
                <th style="width: 18%;">RC to D</th>
              </tr>
            </thead>
            <tbody>
              @for (row of detailRows; track trackByIndex($index)) {
<tr>
                <td><input class="form-control" [value]="row.TAX_YEAR" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.AMOUNT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.PREV_LOSS)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.CO_LOSS)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.LINE8_AMT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.RECLASS_AMT)" readonly /></td>
              </tr>
}
            </tbody>
          </table>
          @if (detailRows.length === 0) {
<div class="no-data">No data returned for this tab and filter set.</div>
}

          <div class="override-grid">
            <div class="override-row">
              <label class="override-label">Override Amount on Line 8 of 4797</label>
              <input type="text" class="form-control text-right override-amount"
                     [ngModel]="override1231Line8"
                     (ngModelChange)="on1231OverrideChange('line8', $event)" />
              <label class="override-comment-label">Comment</label>
              <input type="text" class="form-control override-comment"
                     [ngModel]="override1231Line8Comment"
                     (ngModelChange)="on1231OverrideChange('line8Comment', $event)" />
            </div>
            <div class="override-row">
              <label class="override-label">RC to D</label>
              <input type="text" class="form-control text-right override-amount"
                     [ngModel]="override1231Reclass"
                     (ngModelChange)="on1231OverrideChange('reclass', $event)" />
              <label class="override-comment-label">Comment</label>
              <input type="text" class="form-control override-comment"
                     [ngModel]="override1231ReclassComment"
                     (ngModelChange)="on1231OverrideChange('reclassComment', $event)" />
            </div>
          </div>
        </div>
      
}

      <!-- Capital Loss Analysis -->
      @case ('capital') {

        <div class="divShadow">
          <div class="section-label">Capital Loss Limitation</div>
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 20%;"></th>
                <th style="width: 25%;">Limitation Amount</th>
                <th style="width: 25%;">Override Amount</th>
                <th style="width: 30%;">Comments</th>
              </tr>
            </thead>
            <tbody>
              @for (row of capitalLimitationRows; track trackByIndex($index)) {
<tr>
                <td><input class="form-control" [value]="row.LINE_DESCRIPTION" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.AMOUNT_1)" readonly /></td>
                <td>
                  @if (shouldShowCapitalOverrideInput(row)) {
<input class="form-control text-right"
                         [ngModel]="row.AMOUNT_2"
                         (ngModelChange)="onCapitalAmount2Change(row, $event)" />
}
                </td>
                <td>
                  @if (shouldShowCapitalComment(row)) {
<input class="form-control"
                         [ngModel]="row.COMMENTS"
                         (ngModelChange)="onCapitalCommentsChange(row, $event)" />
}
                </td>
              </tr>
}
            </tbody>
          </table>

          <div class="section-label" style="margin-top:12px;">Capital Loss carryforward</div>
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 20%;"></th>
                <th style="width: 40%;">Amount</th>
                <th style="width: 40%;">Comments</th>
              </tr>
            </thead>
            <tbody>
              @for (entry of capitalCarryforwardRows; track trackByIndex($index)) {
<tr>
                <td><input class="form-control" [value]="entry.row.LINE_DESCRIPTION" readonly /></td>
                <td><input class="form-control text-right"
                           [ngModel]="entry.row.AMOUNT_2"
                           (ngModelChange)="onCapitalAmount2Change(entry.row, $event)" /></td>
                <td><input class="form-control"
                           [ngModel]="entry.row.COMMENTS"
                           (ngModelChange)="onCapitalCommentsChange(entry.row, $event)" /></td>
              </tr>
}
            </tbody>
          </table>
          @if (detailRows.length === 0) {
<div class="no-data">No data returned for this tab and filter set.</div>
}
        </div>
      
}

      <!-- Charitable Contributions Analysis -->
      @case ('charitable') {

        <div class="divShadow">
          <div class="summary-title"><h3>Charitable Contribution Summary</h3></div>
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 25%;">Entity Type</th>
                <th style="width: 25%;">Taxable Line 30</th>
                <th style="width: 25%;">Charitable Contribution Deductions</th>
                <th style="width: 25%;">Form 8916 Line 2d1/2d2</th>
              </tr>
            </thead>
            <tbody>
              @for (row of summaryRows; track trackByIndex($index)) {
<tr>
                <td><input class="form-control" [value]="row.ENTITY_TYPE" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.TI_30_AMT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.CY_CHARITABLE_AMT)" readonly /></td>
                <td><input class="form-control text-right" [value]="formatAmount(row.LINE_2D_AMT)" readonly /></td>
              </tr>
}
            </tbody>
          </table>
          @if (summaryRows.length === 0) {
<div class="no-data">No summary rows for this filter set.</div>
}
        </div>

        <div class="divShadow">
          <table class="table table-hover table-bordered table-striped table-condensed summary-table">
            <thead>
              <tr>
                <th style="width: 60%;"></th>
                <th style="width: 40%;">CarryForward Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (row of detailRows; track trackByIndex(i); let i = $index) {
<tr>
                <td>{{ row.LINE_DESCRIPTION }}</td>
                <td>
                  @if (row.EDITABLE_YN === 'N') {
<input class="form-control text-right"
                         [value]="formatAmount(row.AMOUNT)" readonly />
}
                  @if (row.EDITABLE_YN === 'Y' && row.LINE_KEY !== 'OVERRIDE_8916_LINE_2D_COMMENTS' && row.LINE_KEY !== 'OVERRIDE_PERCENTAGE_OF_TI') {
<input
                         class="form-control text-right"
                         [ngModel]="row.AMOUNT"
                         (ngModelChange)="onCharitableAmountChange(row, i, $event)" />
}
                  @if (row.EDITABLE_YN === 'Y' && row.LINE_KEY === 'OVERRIDE_PERCENTAGE_OF_TI') {
<input
                         class="form-control text-right"
                         [ngModel]="row.AMOUNT"
                         (ngModelChange)="onCharitableAmountChange(row, i, $event)" />
}
                  @if (row.EDITABLE_YN === 'Y' && row.LINE_KEY === 'OVERRIDE_8916_LINE_2D_COMMENTS') {
<input
                         class="form-control"
                         [ngModel]="row.COMMENTS"
                         (ngModelChange)="onCharitableCommentsChange(row, $event)" />
}
                </td>
              </tr>
}
            </tbody>
          </table>
          @if (detailRows.length === 0) {
<div class="no-data">No data returned for this tab and filter set.</div>
}
        </div>
      
}

      <!-- Dividends Received Deductions Worksheet (Schedule C) -->
      @case ('scheduleC') {

        <div class="schedulec-wrapper">
          <div class="panel-block">
            <div class="summary-title"><h3>DRD Limitation Summary</h3></div>
            <table class="table table-hover table-bordered table-striped table-condensed summary-table">
              <thead>
                <tr>
                  <th style="width: 20%;">Entity Type</th>
                  <th style="width: 40%;">Dividend Received Deduction</th>
                  <th style="width: 40%;">DRD Limitation</th>
                </tr>
              </thead>
              <tbody>
                @for (row of summaryRows; track trackByIndex($index)) {
<tr>
                  <td><input class="form-control" [value]="row.ENTITY_TYPE" readonly /></td>
                  <td><input class="form-control text-right" [value]="formatAmount(row.DRD_AMT)" readonly /></td>
                  <td><input class="form-control text-right" [value]="formatAmount(row.LIMITATION_AMT)" readonly /></td>
                </tr>
}
              </tbody>
            </table>
          </div>

          <div class="panel-block worksheet-block">
            <div class="worksheet-header">{{ wsHeader?.LINE_DESCRIPTION || '' }}</div>
            <div class="calc-mode">
              <label>
                <input type="radio" [checked]="isCalc === 'Y'" (change)="onScheduleCCalcModeChange('Y')" />
                Calculate total DRD's from System
              </label>
              <label>
                <input type="radio" [checked]="isCalc === 'N'" (change)="onScheduleCCalcModeChange('N')" />
                Fill up Schedule C Worksheet
              </label>
            </div>

            @if (isCalc === 'N') {
<table class="table table-hover table-bordered table-striped table-condensed summary-table">
              <thead>
                <tr>
                  <th style="width: 20%;">Line number</th>
                  <th style="width: 50%;">Line Description</th>
                  <th style="width: 30%;">Amount</th>
                </tr>
              </thead>
              <tbody>
                @for (row of drdWorksheetRows; track trackByIndex($index)) {
<tr>
                  <td>{{ row.LINE_NO }}</td>
                  <td>{{ row.LINE_DESCRIPTION }}</td>
                  <td>
                    <input class="form-control text-right"
                           [ngModel]="row.AMOUNT"
                           (ngModelChange)="onScheduleCAmountChange(row, $event)"
                           [disabled]="row.IS_EDITABLE_CELL === 'N'" />
                  </td>
                </tr>
}
              </tbody>
            </table>
}

            @if (isCalc === 'Y') {
<div class="override-row">
              <label>Total Dividends Received Deductions</label>
              <input class="form-control text-right" [ngModel]="drdRecord?.AMOUNT" disabled />
            </div>
}

            <div class="override-row">
              <label>Override Amount for Dividends Received Deductions</label>
              <input class="form-control text-right"
                     [ngModel]="overrideAmtRecord?.AMOUNT"
                     (ngModelChange)="overrideAmtRecord.AMOUNT = $event; onScheduleCOverrideChange()" />
              <label>Comment</label>
              <input class="form-control"
                     [ngModel]="overrideAmtRecord?.COMMENTS"
                     (ngModelChange)="overrideAmtRecord.COMMENTS = $event; onScheduleCOverrideChange()" />
            </div>
          </div>

          <div class="actions schedulec-actions">
            <button type="button" class="save-button" [disabled]="saving || loading" (click)="onSave()">
              @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
            </button>
            <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
          </div>
        </div>
      
}
    }

}

    <!-- Shared bottom action bar (legacy modal-footer: Save + Cancel) -->
    @if (!loading && !errorMessage && showFooterButtons) {
<div class="footer-actions">
      <button type="button" class="save-button" [disabled]="saving || loading" (click)="onSave()">
        @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
      </button>
      <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
    </div>
}
  </div>
</div>
}
